<template>
  <div class="incident-timeline">
    <template v-if="incidents.length === 0">
      <EmptyState :title="t('status.incidents.empty')">
        <template #icon>
          <KdsIcon name="check-circle-2" :size="24" aria-hidden="true" />
        </template>
      </EmptyState>
    </template>
    <template v-else>
      <ul class="incident-timeline__list">
        <li
          v-for="(incident, index) in incidents"
          :key="index"
          class="incident-timeline__item"
        >
          <time class="incident-timeline__date" :datetime="incident.date">{{ incident.date }}</time>
          <p class="incident-timeline__title">{{ incident.title }}</p>
          <p v-if="incident.body" class="incident-timeline__body">{{ incident.body }}</p>
        </li>
      </ul>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import EmptyState from '@/components/EmptyState.vue';
import KdsIcon from '@/kds/primitives/KdsIcon.vue';

export interface Incident {
  date: string;
  title: string;
  body?: string;
}

interface Props {
  incidents: Incident[];
}

defineProps<Props>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.incident-timeline {
  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    padding-bottom: var(--space-5);
    border-bottom: var(--border);

    &:last-child {
      border-bottom: none;
    }
  }

  &__date {
    font-size: var(--fs-meta);
    color: var(--stone);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  &__title {
    margin: 0;
    font-size: var(--fs-body);
    font-weight: var(--fw-medium);
    color: var(--ink);
  }

  &__body {
    margin: 0;
    font-size: var(--fs-body-sm);
    color: var(--stone);
  }
}
</style>
